const initialState = {
  selectedGuilds: [],
  guildsList: []
};

export const guilds = (state = initialState, action) => {
  switch (action.type) {
    case 'SETUP_SELECT_GUILD': {
      const index = state.guildsList.findIndex((g) => g.id === action.id);
      if (index === -1) return state;
      let tempArray = [...state.guildsList];
      if (tempArray[index].selected) {
        tempArray[index].selectable = true;
        tempArray[index].currentUser = false;
      }
      tempArray[index].selected = !tempArray[index].selected;
      let selectedGuilds = tempArray.map((e, i) => e.selected === true ? tempArray[i].id : '').filter(String);
      return {
        ...state,
        guildsList: tempArray,
        selectedGuilds
      };
    }
    case 'SET_GUILDS': {
      let tempArray = [...action.guilds];
      let selectedGuilds = tempArray.map((e, i) => e.selected === true ? tempArray[i].id : '').filter(String);
      tempArray.sort(function (a, b) {
        return b["selected"] - a["selected"] || b["selectable"] - a["selectable"];
      });
      return {
        guildsList: tempArray,
        selectedGuilds
      };
    }
    default:
      return state;
  }
};
